/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateOtelDestinationHeaderInput,
  CreateOtelDestinationHeaderInput$Outbound,
  CreateOtelDestinationHeaderInput$outboundSchema,
} from "./createoteldestinationheaderinput.js";

/**
 * OTEL-specific configuration supplied when creating a destination.
 */
export type CreateOtelDestinationInput = {
  /**
   * OTEL collector endpoint URL.
   */
  endpointUrl: string;
  /**
   * Write-only HTTP headers.
   */
  headers: Array<CreateOtelDestinationHeaderInput>;
};

/** @internal */
export type CreateOtelDestinationInput$Outbound = {
  endpoint_url: string;
  headers: Array<CreateOtelDestinationHeaderInput$Outbound>;
};

/** @internal */
export const CreateOtelDestinationInput$outboundSchema: z.ZodMiniType<
  CreateOtelDestinationInput$Outbound,
  CreateOtelDestinationInput
> = z.pipe(
  z.object({
    endpointUrl: z.string(),
    headers: z.array(CreateOtelDestinationHeaderInput$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      endpointUrl: "endpoint_url",
    });
  }),
);

export function createOtelDestinationInputToJSON(
  createOtelDestinationInput: CreateOtelDestinationInput,
): string {
  return JSON.stringify(
    CreateOtelDestinationInput$outboundSchema.parse(createOtelDestinationInput),
  );
}
